<template>
  <div class="affiliate-sales">
    <div v-if="sales" class="sales container">
      <el-row :gutter="20">
        <el-col :md="8">
          <el-card>
            <h4 class="card-title">{{ thisWeekCount }} / {{ thisWeekSales | currency }}</h4>
            <p class="card-text">This Week</p>
          </el-card>
        </el-col>
        <el-col :md="8">
          <el-card>
            <h4 class="card-title">{{ lastWeekCount }} / {{ lastWeekSales | currency }}</h4>
            <p class="card-text">Last Week</p>
          </el-card>
        </el-col>
        <el-col :md="8">
          <el-card>
            <h4 class="card-title">{{ allCount }} / {{ allSales | currency }}</h4>
            <p class="card-text">All Time</p>
          </el-card>
        </el-col>
      </el-row>
      <el-table :data="sales" empty-text="No Sales" :highlight-current-row="false" stripe border>
        <el-table-column label="Date">
          <template slot-scope="scope">
            <span>{{ scope.row.date.year }}-W{{ scope.row.date.week }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Revenue">
          <template slot-scope="scope">
            <span>{{ scope.row.revenue | currency }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Count">
          <template slot-scope="scope">
            <span>{{ scope.row.count }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import api from '@/lib/api'
import license from '@/lib/license'

export default {
  name: 'AffiliateSales',
  data() {
    return {
      loading: false,
      sales: null
    }
  },
  filters: {
    currency(val) {
      return '$' + parseFloat(val).toLocaleString('en', {
        useGrouping: true,
        minimumFractionDigits: 2
      })
    }
  },
  computed: {
    thisWeekSales() {
      return this.sales[0].revenue
    },
    thisWeekCount() {
      return this.sales[0].count
    },
    lastWeekSales() {
      return this.sales[1].revenue
    },
    lastWeekCount() {
      return this.sales[1].count
    },
    allSales() {
      return this.sales.reduce((total, sale) => total + sale.revenue, 0)
    },
    allCount() {
      return this.sales.reduce((total, sale) => total + sale.count, 0)
    }
  },
  methods: {
    async refresh() {
      this.sales = await api.affiliateSales()
    }
  },
  async mounted() {
    if (license.requireAuth(this)) return
    await this.refresh()
  }
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';
.affiliate-sales {
  min-height: 600px;

  .login.container {
    padding: 150px 8px 200px 8px;
  }

  .sales.container {
    padding: 40px 12px;
  }

  .btn-primary {
    color: #fff !important;
    width: 100%;
  }

  .input-group-text {
    width: 120px;
  }

  .btn {
    text-transform: none;
    border: none;
    padding: 10px;
  }

  .el-table {
    margin-top: 40px;
  }
}
</style>
